import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-report-death-details.component.scss';
var FormItemReportDeathDetails = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemReportDeathDetails, _super);
    function FormItemReportDeathDetails(element) {
        var _this = _super.call(this, element) || this;
        _this.gRecaptchaToken = '';
        _this.emailAddress = [
            {
                name: "Western_Cape",
                email: "enterprisedirect.westerncape@standardbank.co.za"
            }, {
                name: "Mpumalanga",
                email: "enterprisemp@standardbank.co.za"
            }, {
                name: "Eastern_Cape",
                email: "enterprisedirect.easterncape@standardbank.co.za "
            }, {
                name: "North_West",
                email: "directcst.northwest@standardbank.co.za"
            }, {
                name: "Free_State",
                email: "enterprisedirectfsnc@standardbank.co.za"
            }, {
                name: "Kwa_Zulu_Natal",
                email: "directlifestylesupportkzn@standardbank.co.za "
            }, {
                name: "Limpopo",
                email: "enterpriselp@standardbank.co.za"
            }, {
                name: "Northern_Cape",
                email: "enterprisedirectfsnc@standardbank.co.za"
            }, {
                name: "Ekurhuleni",
                email: "ekurhuleni.businessbanking@standardbank.co.za"
            }, {
                name: "CityOfJohannesburg",
                email: "COJ.businessbanking@standardbank.co.za"
            }, {
                name: "CityOfTshwane",
                email: "tshwane.businessbanking@standardbank.co.za"
            }, {
                name: "MetswedingDistrict",
                email: "tshwane.businessbanking@standardbank.co.za"
            }, {
                name: "SedibengDistrict",
                email: "ekurhuleni.businessbanking@standardbank.co.za"
            }, {
                name: "WestRandDistrict",
                email: "coj.businessbanking@standardbank.co.za "
            }
        ];
        return _this;
    }
    FormItemReportDeathDetails.prototype.init = function () {
        // form
        this.form = this.element.querySelector('form');
        this.submitBtn = Array.from(this.element.querySelectorAll('.js-reportDeath__button--submit'));
        this.applyFormRadio = Array.from(this.element.querySelectorAll('.js-identification_radio--group'));
        this.wizard = this.element.querySelector('.form-container-wizard__wizard');
        // buttons
        this.submitBtn = Array.from(this.element.querySelectorAll('.js-reportDeath__button--submit'));
    };
    FormItemReportDeathDetails.prototype.bindEvents = function () {
        var _this = this;
        this.applyFormRadio.map(function (item) { return item.addEventListener('click', function (event) {
            var evt = event.target;
            var identificationField = _this.form.querySelector('input[name=identification]');
            var identificationType = evt.value;
            if (identificationType === 'said') {
                identificationField.classList.remove('form__input--identification--passport');
                identificationField.classList.add('form__input--identification');
                identificationField.placeholder = 'Enter your South African ID number';
                identificationField.type = 'number';
            }
            else {
                identificationField.classList.remove('form__input--identification');
                identificationField.classList.add('form__input--identification--passport');
                identificationField.placeholder = 'Enter your Passport number';
                identificationField.type = 'text';
            }
        }); });
        this.submitBtn.map(function (item) { return item.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll('.form__group--error'));
            if (valid.length === 0) {
                // loader + hide form
                var loader = _form.querySelector(".form__loader--container");
                var fieldsContainer = _form.querySelector(".form__fields--container");
                loader.classList.add("active");
                fieldsContainer.classList.add("hidden");
                // Check if gRecaptcha is enabled for this form
                if (grecaptcha != null && _this.formsService.getGRecaptchaSiteKey() != '') {
                    var gToken_1 = '';
                    try {
                        // Attempt to get recaptcha token
                        grecaptcha.enterprise.ready(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var err_1;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, grecaptcha.enterprise.execute(this.formsService.getGRecaptchaSiteKey(), { action: 'LOGIN' })];
                                    case 1:
                                        gToken_1 = _a.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_1 = _a.sent();
                                        // Log error
                                        console.log("Unable to retrieve gRecaptcha Token");
                                        console.log(err_1);
                                        return [3 /*break*/, 3];
                                    case 3:
                                        // Set recaptcha token
                                        this.gRecaptchaToken = gToken_1;
                                        this.submitForm(_form);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                    catch (err) {
                        // Log error
                        console.log("Unable to retrieve gRecaptcha Token");
                        console.log(err);
                        _this.submitForm(_form);
                    }
                }
                else {
                    _this.submitForm(_form);
                }
            }
        }); });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll('input, select, textarea'));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener('custom_form_reset_event', function (e) {
            if (_this.wizard) {
                var event_1 = new CustomEvent('custom_wizard_reset_event');
                _this.wizard.dispatchEvent(event_1);
            }
        }, false);
    };
    FormItemReportDeathDetails.prototype.updateSuccessEmail = function (pId, split) {
        var _emailAddress = '';
        if (split === "CST") {
            for (var i = 0; i < this.emailAddress.length; i++) {
                if (this.emailAddress[i].name === _emailAddress) {
                    _emailAddress = this.emailAddress[i].email;
                    break;
                }
            }
        }
        else {
            _emailAddress = 'STLEstatesDistributionCentre@standardbank.co.za';
        }
        var _emailLink = this.element.querySelector("span.js-report-death__email");
        _emailLink.innerHTML = '';
        var _subject = "Documentation for application: ";
        var _body = "To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\nDeceased's Death Certificate(JPG, PNG OR PDF)";
        var _mailToText = "mailto:" + _emailAddress + "?subject=" + encodeURIComponent(_subject) + "&body=" + encodeURIComponent(_body);
        var _newButton = document.createElement("a");
        _newButton.textContent = 'EMAIL DOCUMENTS';
        _newButton.setAttribute('style', 'color:white;');
        _newButton.setAttribute("data-id", "link_content_ documents email click");
        _newButton.setAttribute("data-text", "email documents button click");
        _newButton.setAttribute("href", _mailToText);
        _emailLink.appendChild(_newButton);
    };
    FormItemReportDeathDetails.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        // additional containers
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        var name = Array.from(form.querySelectorAll('.form__success-container__firstname'));
        var _initialForm = form.querySelector('.form__fields--container');
        // loader + hide form
        loader.classList.add('active');
        _initialForm.classList.add('hidden');
        _initialForm.classList.remove('active');
        var emailPostData = '';
        var _analyticsFlag = document.querySelector(".splitFlag");
        var _split = (_analyticsFlag ? 'CST' : "DFC");
        emailPostData += "splitFlag=" + (_analyticsFlag ? 'CST' : "DFC");
        // hidden fields
        var description = form.querySelector('input[name=description]');
        emailPostData += 'description=' + ((description) ? description.value : '');
        var email = form.querySelector('input[name=email]');
        emailPostData += '&email=' + ((email) ? email.value : '');
        var recipient = form.querySelector('input[name=recipient]');
        emailPostData += '&recipient=' + ((recipient) ? recipient.value : '');
        var subject = form.querySelector('input[name=subject]');
        emailPostData += '&subject=' + ((subject) ? subject.value : '');
        var product = form.querySelector('input[name=product]');
        emailPostData += '&product=' + ((product) ? product.value : '');
        var redirect = form.querySelector('input[name=redirect]');
        emailPostData += '&redirect=' + ((redirect) ? redirect.value : '');
        // form fields
        var _firstName = form.querySelector('input[name=first-name]');
        emailPostData += '&first-name=' + ((_firstName) ? _firstName.value : '');
        var _surname = form.querySelector('input[name=surname]');
        emailPostData += '&surname=' + ((_surname) ? _surname.value : '');
        var _contactNumber = form.querySelector('input[name=phone-number]');
        emailPostData += '&phone-number=' + ((_contactNumber) ? _contactNumber.value : '');
        var _email = form.querySelector('input[name=email-address]');
        emailPostData += '&email-address=' + ((_email) ? _email.value : '');
        var _deceasedFirstName = form.querySelector('input[name=deceased-first-name]');
        emailPostData += '&deceasedFirstName=' + ((_deceasedFirstName) ? _deceasedFirstName.value : '');
        var _deceasedSurname = form.querySelector('input[name=deceased-surname]');
        emailPostData += '&deceasedSurname=' + ((_deceasedSurname) ? _deceasedSurname.value : '');
        var _idNumber = form.querySelector('input[name=identification]');
        emailPostData += '&saId=' + ((_idNumber) ? _idNumber.value : '');
        emailPostData += '&recaptchaToken=' + this.gRecaptchaToken;
        if (name) {
            name.map(function (_item) {
                _item.innerHTML = _firstName.value;
            });
        }
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + '/services/SubmitGenericForm.jsp';
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        this.formsService.postForm(url, emailPostData, config).then(function (response) {
            loader.classList.remove('active');
            // tslint:disable-next-line: comment-format
            //Always show success message / no response from server (sending email)
            analyticsService.dtmFormComplete('complete', response.code);
            thankYou.classList.add('active');
            error.classList.remove('active');
            error.classList.add('hidden');
            success.classList.remove('hidden');
            success.classList.add('active');
            _this.updateSuccessEmail(_idNumber.value, _split);
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            _initialForm.classList.remove('hidden');
        });
    };
    return FormItemReportDeathDetails;
}(Base));
export { FormItemReportDeathDetails };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-report-death-details/form-item-report-death-details.component.ts
// module id = 973
// module chunks = 0